/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["accepted-payments-header{display:block;border-bottom:1px solid #e0e0e0;margin-bottom:15px}accepted-payments-header>.text{font-size:1.6rem;margin-bottom:15px}accepted-payments-header .card-icons{display:flex;align-items:flex-start;flex-wrap:wrap;margin-bottom:25px}accepted-payments-header .card-icons>img{margin-right:5px;width:50px;height:auto;margin-bottom:5px}"];
export { styles as styles };
